/* GarmentGoods – dark mode toggle + legal page navigation */
(function () {
  'use strict';
  var d = document.documentElement;
  var KEY = 'gg-theme';
  function meta(c) { var m = document.querySelector('meta[name="theme-color"]'); if (m) m.setAttribute('content', c); }
  function apply(mode, animate) {
    if (animate) { d.classList.add('theme-anim'); setTimeout(function () { d.classList.remove('theme-anim'); }, 450); }
    if (mode === 'dark') d.setAttribute('data-theme', 'dark'); else d.removeAttribute('data-theme');
    meta(getComputedStyle(d).getPropertyValue('--bg').trim() || (mode === 'dark' ? '#121111' : '#ffffff'));
    document.querySelectorAll('[data-theme-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false'); });
  }
  apply(d.getAttribute('data-theme') === 'dark' ? 'dark' : 'light', false);
  var DUR = 1400, EASE = 'cubic-bezier(.65,0,.25,1)';
  function rollLogo() {
    var s = document.querySelector('.logo:not(.logo--img) > span'); if (!s || !s.animate) return;
    if (!s.dataset.split) {
      var sup = s.querySelector('sup'), txt = '';
      Array.prototype.forEach.call(s.childNodes, function (n) { if (n.nodeType === 3) txt += n.textContent; });
      s.textContent = '';
      Array.prototype.forEach.call(txt, function (ch) { var c = document.createElement('span'); c.className = 'lg-ch'; c.textContent = ch; s.appendChild(c); });
      if (sup) s.appendChild(sup);
      s.dataset.split = '1';
    }
    Array.prototype.forEach.call(s.querySelectorAll('.lg-ch, sup'), function (c, i) {
      c.animate([{ transform: 'translateY(110%)' }, { transform: 'none' }], { duration: 700, delay: 260 + i * 30, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-theme-toggle]'); if (!b) return;
    var next = d.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    try { sessionStorage.setItem(KEY, next); } catch (err) {}
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (calm || !document.startViewTransition) { apply(next, !calm); return; }
    var r = b.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + r.height / 2;
    var W = window.innerWidth, H = window.innerHeight;
    var S = 2 * Math.hypot(Math.max(x, W - x), Math.max(y, H - y)) / 0.86 + 60;
    d.classList.add('vt-theme');
    var vt = document.startViewTransition(function () { apply(next, false); rollLogo(); });
    vt.ready.then(function () {
      var from = x + 'px ' + y + 'px', to = (x - S / 2) + 'px ' + (y - S / 2) + 'px';
      d.animate({
        maskSize: ['0px 0px', S + 'px ' + S + 'px'], WebkitMaskSize: ['0px 0px', S + 'px ' + S + 'px'],
        maskPosition: [from, to], WebkitMaskPosition: [from, to],
        filter: ['blur(8px)', 'blur(0px)']
      }, { duration: DUR, easing: EASE, pseudoElement: '::view-transition-new(root)' });
    }).catch(function () {});
    vt.finished.then(function () { d.classList.remove('vt-theme'); }, function () { d.classList.remove('vt-theme'); });
  });

  /* legal page: smooth jump + highlight the section in view */
  var links = Array.prototype.slice.call(document.querySelectorAll('[data-legal-link]'));
  if (!links.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setActive(id) {
    links.forEach(function (a) {
      var on = a.getAttribute('href') === '#' + id;
      a.classList.toggle('is-active', on);
      if (on && a.scrollIntoView && window.innerWidth < 810) a.parentNode.scrollTo({ left: a.offsetLeft - 18, behavior: reduce ? 'auto' : 'smooth' });
    });
  }
  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', a.getAttribute('href'));
      setActive(t.id);
    });
  });
  var docs = Array.prototype.slice.call(document.querySelectorAll('[data-legal-doc]'));
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) setActive(en.target.id); });
    }, { rootMargin: '-30% 0px -60% 0px' });
    docs.forEach(function (x) { io.observe(x); });
  }
  var start = location.hash.slice(1);
  setActive(start && document.getElementById(start) ? start : (docs[0] && docs[0].id));
})();
